import { render, staticRenderFns } from "./DataFormShell.vue?vue&type=template&id=f21a6304&scoped=true"
import script from "./DataFormShell.vue?vue&type=script&lang=js"
export * from "./DataFormShell.vue?vue&type=script&lang=js"
import style0 from "./DataFormShell.vue?vue&type=style&index=0&id=f21a6304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_5hxyaa5b57h6kqtn5hqvbk3bcu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21a6304",
  null
  
)

export default component.exports